import { validationRules } from "../../utils/validation";

export const riskAssesmentInfoSchema = {
    pep: [
        validationRules.required("Have you undertaken PEP & Sanctions screenings on and the +25% ultimate beneficial owners?** is required"),
    ],
   
    pepOwner: [
        validationRules.required("Is the client/counterparty or beneficial owner a PEP (Politically Exposed Person), a family member of a PEP or a known close associate of a PEP?** is required"),
    ],
    sanctionedPerson: [
        validationRules.required("Is the client/counterparty or beneficial owner a “Sanctioned Person”? * is required"),
    ],
    understandClientBussiness: [
        validationRules.required("Do you understand this client/counterparty's overall business? * is required"),
    ],
    understandClientBussinessExplanation: [
        validationRules.required("Explanation for client/counterparty's overall business is required"),
    ],

    particularTransaction: [
        validationRules.required("Do you understand why they are entering this particular transaction? * required"),
    ],
    particularTransactionExplanation: [
        validationRules.required("Explanation for why they are entering this particular transaction is required"),
    ],
    terroristFinancing: [
        validationRules.required("Have you found any evidence of legal and/or regulatory sanction or enforcement in relation to proliferation and/or terrorist financing?* is required"),
    ],

    sectorFromDropdown: [
        validationRules.required("Does your client/counterparty belong to any of the following sectors? is required"),
    ],
   
    cashIntensive: [
        validationRules.required("Has the client/counterparty insisted that the transaction be completed with undue speed, including, for illustration, avoiding normal searches and enquiries? is required"),
    ],

    pepEvasive: [
        validationRules.required("Has the client/counterparty been evasive or unusually reluctant to provide you with information and/or documents? is required"),
    ],
    financialCrime: [
        validationRules.required("Have you found any evidence of legal and/or regulatory sanction or enforcement in relation to financial crime? * is required"),
    ],
    transactionCompletedWithUndueSpeed: [
        validationRules.required("Has the client/counterparty insisted that the transaction be completed with undue speed? is required"),
    ],

 
    adverseSearch: [
        validationRules.required("Have you conducted an adverse media search on the client/counterparty and its beneficial owners? is required"),
    ],

    
    adversePublicity: [
        validationRules.required("Have your media searches revealed any adverse publicity in relation to the client/counterparty? is required"),
    ],
    
    adverseInformation: [
        validationRules.required("Have you been made aware of any other adverse information in relation to this client/counterparty or its UBOs? is required"),
    ],
    
    criminalProceedings: [
        validationRules.required("Had the client/counterparty or UBO been previously subject to criminal proceedings of any nature? is required"),
    ],
    taxInvasionIndication: [
        validationRules.required("Are there any indications that the transaction would facilitate tax evasion? is required"),
    ],

    InfluenceTransaction: [
        validationRules.required("Does the transaction involve an intermediary who has the ability to influence/ control the transaction? is required"),
    ],
    


}

export const isIntermediaryName = {
    IntermediaryName: [
        validationRules.required("Name of intermediary/ lead contact is required"),
    ],
    IntermediaryRole: [
        validationRules.required("Role of Intermediary/Lead Contact is required"),
    ],
}
